import { makeRequest } from 'utils/requestLogger';

export default (submissionID, payload) =>
  makeRequest(
    'put',
    `/api/submissions/${submissionID}/toggle_hide_submission`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/toggleHideSubmission.js